(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea579"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea579"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("fWbcT", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $b9a4f744ab95abc4$export$6503ec6e8aabbaf; }, function (v) { return $b9a4f744ab95abc4$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $b9a4f744ab95abc4$export$f7ad0328861e2f03; }, function (v) { return $b9a4f744ab95abc4$export$f7ad0328861e2f03 = v; });
var $b9a4f744ab95abc4$export$6503ec6e8aabbaf;
var $b9a4f744ab95abc4$export$f7ad0328861e2f03;
"use strict";
var $b9a4f744ab95abc4$var$mapping = new Map();
function $b9a4f744ab95abc4$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$b9a4f744ab95abc4$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $b9a4f744ab95abc4$var$resolve(id) {
    var resolved = $b9a4f744ab95abc4$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$b9a4f744ab95abc4$export$6503ec6e8aabbaf = $b9a4f744ab95abc4$var$register;
$b9a4f744ab95abc4$export$f7ad0328861e2f03 = $b9a4f744ab95abc4$var$resolve;

});

parcelRegister("dOGL2", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $a0f11cae5038e8ee$export$bdfd709ae4826697; }, function (v) { return $a0f11cae5038e8ee$export$bdfd709ae4826697 = v; });
var $a0f11cae5038e8ee$export$bdfd709ae4826697;
var $a0f11cae5038e8ee$export$c9e73fbda7da57b6;
var $a0f11cae5038e8ee$export$5a759dc7a1cfb72a;
"use strict";
var $a0f11cae5038e8ee$var$bundleURL = {};
function $a0f11cae5038e8ee$var$getBundleURLCached(id) {
    var value = $a0f11cae5038e8ee$var$bundleURL[id];
    if (!value) {
        value = $a0f11cae5038e8ee$var$getBundleURL();
        $a0f11cae5038e8ee$var$bundleURL[id] = value;
    }
    return value;
}
function $a0f11cae5038e8ee$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $a0f11cae5038e8ee$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $a0f11cae5038e8ee$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $a0f11cae5038e8ee$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$a0f11cae5038e8ee$export$bdfd709ae4826697 = $a0f11cae5038e8ee$var$getBundleURLCached;
$a0f11cae5038e8ee$export$c9e73fbda7da57b6 = $a0f11cae5038e8ee$var$getBaseURL;
$a0f11cae5038e8ee$export$5a759dc7a1cfb72a = $a0f11cae5038e8ee$var$getOrigin;

});

parcelRegister("7QQFy", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("knZtH")),
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("e8vpy"))
]).then(function() {
    return parcelRequire("baVM7");
});

});
parcelRegister("gZJRp", function(module, exports) {
"use strict";

var $bzWhm = parcelRequire("bzWhm");
module.exports = $bzWhm(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRegister("bzWhm", function(module, exports) {
"use strict";
var $86e02b94fb59de77$var$cachedBundles = {};
var $86e02b94fb59de77$var$cachedPreloads = {};
var $86e02b94fb59de77$var$cachedPrefetches = {};
function $86e02b94fb59de77$var$getCache(type) {
    switch(type){
        case "preload":
            return $86e02b94fb59de77$var$cachedPreloads;
        case "prefetch":
            return $86e02b94fb59de77$var$cachedPrefetches;
        default:
            return $86e02b94fb59de77$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $86e02b94fb59de77$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments)["catch"](function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("bsVNx", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("gzRlQ")),
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("knZtH")),
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("4kPaV"))
]).then(function() {
    return parcelRequire("8irMg");
});

});

parcelRegister("2T8oU", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("knZtH")),
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("c3r6u"))
]).then(function() {
    return parcelRequire("aXh96");
});

});

parcelRegister("LZQH8", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("knZtH")),
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("8Akk5"))
]).then(function() {
    return parcelRequire("5SZvv");
});

});

parcelRegister("3AZQX", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("knZtH")),
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("dQFsw"))
]).then(function() {
    return parcelRequire("acR8M");
});

});

parcelRegister("aBfhO", function(module, exports) {


module.exports = (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("hC8py")).then(function() {
    return parcelRequire("dBisn");
});

});

parcelRegister("kMlul", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("knZtH")),
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("aGM1O"))
]).then(function() {
    return parcelRequire("hyoMN");
});

});

parcelRegister("4Xpco", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("2Xexv")),
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("hreBQ"))
]).then(function() {
    return parcelRequire("j8x1l");
});

});

parcelRegister("fGVAf", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("2Xexv")),
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("gVrro"))
]).then(function() {
    return parcelRequire("h7ahp");
});

});

parcelRegister("a4bhl", function(module, exports) {


module.exports = (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("5mOJi")).then(function() {
    return parcelRequire("ffy68");
});

});

parcelRegister("jFHIS", function(module, exports) {


module.exports = (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("9gWdq")).then(function() {
    return parcelRequire("jtOqf");
});

});

parcelRegister("YDlW4", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("gzRlQ")),
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("knZtH")),
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("dmFhl"))
]).then(function() {
    return parcelRequire("gMG8A");
});

});

parcelRegister("aVtjy", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("knZtH")),
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("9khn8"))
]).then(function() {
    return parcelRequire("ateEk");
});

});

var $67958ecaa1491cd7$exports = {};


(parcelRequire("fWbcT")).register((parcelRequire("dOGL2")).getBundleURL("9Am0b"), JSON.parse('["9Am0b","as-legacy.js","e8vpy","asCaritasJobs.module.0fd7a4a9.js","knZtH","asCaritasJobs.module.76188a7b.js","4kPaV","asCaritasLocations.module.2a4e3e87.js","gzRlQ","asCaritasLocations.module.1e06a76c.js","c3r6u","banner.module.5edefe7e.js","8Akk5","flyout.module.ccdfd8e9.js","dQFsw","lightbox.module.5c7859be.js","hC8py","modal.module.330c8bfc.js","aGM1O","panels.module.5c917b68.js","hreBQ","plyr-modal.module.d05a9d1b.js","2Xexv","plyr-modal.module.3420e590.js","gVrro","plyr.module.f99420ed.js","5mOJi","salaryTables.module.55e821d1.js","9gWdq","sharing.module.bb577fdd.js","dmFhl","slider.module.adbfc1d2.js","9khn8","ceJobSearch.module.a6574e87.js"]'));

// =============================================================
// IMPORTS
// =============================================================
// =============================================================
// MODULES
// - Lazy loaded modules which are imported when needed
// =============================================================

if (document.querySelectorAll("#asjc-url").length > 0) (parcelRequire("7QQFy")).then(function(module) {
    module.init();
});

if (document.querySelectorAll("#acl-list").length > 0) (parcelRequire("bsVNx")).then(function(module) {
    module.init();
});

if (document.querySelectorAll(".banner").length > 0) (parcelRequire("2T8oU")).then(function(module) {
    module.init();
});

if (document.querySelectorAll(".main-nav").length > 0) (parcelRequire("LZQH8")).then(function(module) {
    module.init();
});

if (document.querySelectorAll(".lightbox").length > 0) (parcelRequire("3AZQX")).then(function(module) {
    module.init();
});

if (document.querySelectorAll(".modal")) (parcelRequire("aBfhO")).then(function(module) {
    module.init();
});

if (document.querySelectorAll("section .panel").length > 0) (parcelRequire("kMlul")).then(function(module) {
    module.init();
});

if (document.querySelectorAll('[data-js="content-video-1"]').length > 0) (parcelRequire("4Xpco")).then(function(module) {
    module.init();
});

if (document.querySelectorAll(".video-embed-item").length > 0) (parcelRequire("fGVAf")).then(function(module) {
    module.init();
});

if (document.querySelectorAll(".ctype-ce_salary_tables").length > 0) (parcelRequire("a4bhl")).then(function(module) {
    module.init();
});

if (document.querySelector(".btn--share-facebook") || document.querySelector(".btn--share-twitter") || document.querySelector(".btn--share-linkedin") || document.querySelector(".btn--share-xing") || document.querySelector(".btn--share-telegram") || document.querySelector(".btn--share-whatsapp") || document.querySelector(".btn--share-mail")) (parcelRequire("jFHIS")).then(function(module) {
    module.init();
});

if (document.querySelectorAll(".content-slider").length > 0) (parcelRequire("YDlW4")).then(function(module) {
    module.init();
});

if (document.querySelectorAll(".ctype-ce_job_search .form").length > 0) (parcelRequire("aVtjy")).then(function(module) {
    module.init();
});
// =============================================================
// OTHER
// =============================================================
var $765f16911476d698$var$jobListIndex = location.pathname.indexOf("/jobs");
var $765f16911476d698$var$jobOffersIndex = location.pathname.indexOf("/stellenangebote");
var $765f16911476d698$var$jobDevIndex = location.pathname.indexOf("/as-jobs");
var $765f16911476d698$var$jobOfferIndex = location.pathname.indexOf("/jobs/angebot");
var $765f16911476d698$var$devIndex = location.pathname.indexOf("/bewerben/stellenangebote/detail");
var $765f16911476d698$var$socialLinks = document.querySelector(".social-links");
var $765f16911476d698$var$shareLinks = document.querySelector(".share-links");
if ($765f16911476d698$var$jobListIndex === -1 && $765f16911476d698$var$jobOffersIndex === -1 && $765f16911476d698$var$jobDevIndex === -1) localStorage.removeItem("prevFlag");
if ($765f16911476d698$var$jobOfferIndex > -1 || $765f16911476d698$var$devIndex > -1) {
    $765f16911476d698$var$socialLinks && $765f16911476d698$var$socialLinks.classList.add("hide");
    $765f16911476d698$var$shareLinks && $765f16911476d698$var$shareLinks.classList.remove("hide");
} else $765f16911476d698$var$socialLinks && $765f16911476d698$var$socialLinks.classList.remove("hide");
 // =============================================================
 // WHEN COMPLETE
 // functions which are called when the page is fully loaded
 // =============================================================
 // const whenComplete = () => {
 //   if (document.readyState === "complete") {
 //     // -------------------------------------------------------------
 //     // for example: general "on" listeners
 //     // -------------------------------------------------------------
 //     window.addEventListener("resize", function (e) {
 //       console.log("resize");
 //     });
 //     // -------------------------------------------------------------
 //   } else {
 //     setTimeout(function () {
 //       whenComplete();
 //     }, 400);
 //   }
 // };
 // whenComplete();
 // =============================================================
 // STYLES COMPLETE
 // Removes styles_essential when general styles are loaded
 // =============================================================
 // let styleAttempts = 0;
 // const stylesComplete = () => {
 //   if (styleAttempts > 30) return;
 //   styleAttempts += 1;
 //   if (document.querySelector("#spreld").getAttribute("rel") === "stylesheet") {
 //     document.querySelector("#sess").remove();
 //   } else {
 //     setTimeout(function () {
 //       stylesComplete();
 //     }, 300);
 //   }
 // };
 // stylesComplete();

})();
//# sourceMappingURL=as-legacy.js.map
